import React, { useEffect, useState } from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import "../Style.css";

const ImageSlider = () => {
  const [mounted, setMounted] = useState(false);

  useEffect(() => {
    // Mount after initial paint to prevent render blocking
    const timer = setTimeout(() => setMounted(true), 100); // small delay
    return () => clearTimeout(timer);
  }, []);

  const settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 5,
    slidesToScroll: 1,
    centerMode: true,
    centerPadding: "0",
    autoplay: true,
    autoplaySpeed: 3000,
    lazyLoad: "ondemand",
  };

  const images = [
    "/bn1.webp",
    "/bn2.webp",
    "/bn3.webp",
    "/bn4.webp",
    "/bn5.webp",
    "/bn2.webp",
  ];

  return (
    <div className="slider-container">
      <div className="gradient-overlay">
        {mounted && (
          <Slider {...settings}>
            {images.map((image, index) => (
              <div key={index} className="slide">
                <img
                  src={image}
                  alt={`Slide ${index + 1}`}
                  width="290"
                  height="450"
                  loading={index === 0 ? "eager" : "lazy"}
                  fetchpriority={index === 0 ? "high" : "auto"}
                  style={{
                    width: "290px",
                    height: "450px",
                    borderRadius: "10px",
                    transition: "transform 0.5s ease",
                  }}
                />
              </div>
            ))}
          </Slider>
        )}
      </div>
    </div>
  );
};

export default ImageSlider;
